import { combineReducers } from 'redux';
import { dashboard } from './DashboardReducer';
import { authorization } from './AuthReducer';

/*
* See http://redux.js.org/docs/basics/Reducers.html for more information on Redux Reducers
*/

/*
* The Root Reducer combines all sub reducers
*
* The root reducer is then used in index.js to create the Redux Store
*/
const rootReducer = combineReducers({
  dashboard,
  authorization,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/Reducers/RootReducer.js